
<template>
  <v-container class="container">
    <div>
      <h3>
        <v-icon class="mt-n1 mr-1" style="font-size: 35px"
          >mdi-file-excel</v-icon
        >Carga excel Egresos
      </h3>
      <h6 class="mt-n2 ml-10">Carga masiva de egresos a través de excel</h6>
    </div>
    <v-card class="mt-10">
      <v-card-text>
        <v-row>
          <p class="ml-8 subtitle">Descargar plantilla de Carga <a href="/files/FormularioEgresos.xlsx" download>Pinchando Aqui</a></p>
        </v-row>
        <v-row>
          <v-file-input
            v-model="file"
            label="Seleccionar archivo"
            outlined
            dense
            :rules="fileRules"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="onChange"
          ></v-file-input>
        </v-row>
        <v-row>
          <v-btn @click="readExcel" :disabled="!isFileValid" >Cargar Excel</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import * as XLSX from "xlsx";
import { EgresosService } from "../../util/Api/Egresos/calls";
import { mapGetters } from "vuex";
import { Loading } from "element-ui";
import Swal from "sweetalert2";

export default {
  name: "IngresoMultaComponents",
  components: {},
  data() {
    return {
      file: null,
      jsonData: null,
      fileRules: [
        (v) => !!v || 'Debe seleccionar un archivo',
        (v) => !v || v.size <= 5 * 1024 * 1024 || 'El archivo no debe superar los 5MB',
        (v) => !v || v.type.includes('spreadsheetml') || v.type.includes('ms-excel') || 'El archivo debe ser un .xlsx'
      ]
    };
  },
  computed: {
    ...mapGetters(["getPerfil"]),
    isFileValid() {
      if (!this.file) return false;
      return this.fileRules.every(rule => rule(this.file) === true);
    }
  },

  methods: {
    onChange(event) {
      this.jsonData = null;
    },

    readExcel() {
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        if (!this.file) return;

        const reader = new FileReader();

        reader.onload = async (e) => {
          try {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "binary",cellDates: true, dateNF:"yyyymmdd",  cellNF: false,
            cellText: false });

            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            this.jsonData = XLSX.utils.sheet_to_json(worksheet);

            const requiredFields = [
            'tiporeembolso', 'nombrereembolso', 'montopago',
            'tipoeleccion', 'nombreeleccion', 'rut', 'dv', 'apellidopaterno',
            'rutbeneficiario', 'dvbeneficiario','apellidopaternobeneficiario',
            'telefono', 'direccioncalle', 'direccionnumero',
            'direcciontipocalle', 'codigocomuna', 'correoelectronico'
            ];

            const fechaorigren=new Date();
            const result = this.jsonData.map((obj, index) => {
              requiredFields.forEach((field) => {
                if (!obj.hasOwnProperty(field)) {
                  throw new Error(
                    `El Egreso en la posición ${index} no tiene el campo requerido: ${field}`
                  );
                }
              });
              return {
                ...obj,
                fechaeleccion: obj.fechaeleccion ? `${obj.fechaeleccion.getFullYear()}${String(obj.fechaeleccion.getMonth() + 1).padStart(2, '0')}${String(obj.fechaeleccion.getDate()).padStart(2, '0')}` : null,
                fechaorigen: fechaorigren.toISOString(),
                agnotrimestre: fechaorigren.getFullYear(),
                numerotrimestre: Math.ceil((fechaorigren.getMonth() + 1) / 3),
                ambienteorigen: obj.ambienteorigen || "TEST",
                idconceptopago: obj.idconceptopago || "FINANCIAMIENTO_PUBLICO_ELECTORAL",
                tipopersona: obj.rut < 50000000 ? "NATURAL" : "JURIDICA",
                rut:Number(obj.rut),
                dv: obj.dv.toString() || null,
                nombre: obj.nombre ? obj.nombre : null,
                apellidomaterno: obj.apellidomaterno ? obj.apellidomaterno : null,
                tipopersonabeneficiario: obj.rutbeneficiario < 50000000 ? "NATURAL" : "JURIDICA",
                rutbeneficiario: Number(obj.rutbeneficiario),
                dvbeneficiario:  obj.dvbeneficiario.toString(),
                nombrebeneficiario: obj.nombrebeneficiario || null,
                apellidomaternobeneficiario: obj.apellidomaternobeneficiario || null,
                idsexobeneficiario: obj.idsexobeneficiario ? Number(obj.idsexobeneficiario) : null,
                idcorreoelectronico: "CONTACTO",
                direccionnumero: obj.direccionnumero? obj.direccionnumero.toString() : null,
                direcciondepto: obj.direcciondepto? obj.direcciondepto.toString() : null,
                idtipomoneda:obj.idtipomoneda ? String(obj.idtipomoneda) : "CLP",
                numerocuentapago: obj.numerocuentapago ? Number(obj.numerocuentapago) : null,
                tipocuentapago: obj.tipocuentapago ? String(obj.tipocuentapago) : null,
                bancopagosbif: obj.bancopagosbif ? Number(obj.bancopagosbif) : null,
                telefono: obj.telefono ? Number(obj.telefono) :null ,
                tipoeleccion:obj.tipoeleccion ? Number(obj.tipoeleccion): 0
              };
            });

            const body = {
              idusuario: this.getPerfil.id,
              idsubdireccion: this.getPerfil.subdireccion_id,
              data: result,
            };
            const resp = await EgresosService.send(body);
  
            if (resp.statusCode != 200 && resp.statusCode != 201) {
              throw JSON.stringify(resp.msg)
            }


            Swal.fire({ type: "success", html: `Egreso Enviado` });   
          } catch (error) {
            console.log("error", error);
            Swal.fire({
              type: "error",
              html: `Error al Generar el Egreso: ${error}`,
            });
              }finally{
                this.loadingInstance.close();
              }
            };

       reader.readAsBinaryString(this.file);
        
      } catch (error) {

        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al leer el archivo: ${error}`,
        });
      }
    },
  },
};
</script>

<style scoped>
.container {
  text-align: start !important;
}
</style>
